import React, { useEffect, useCallback } from 'react'
import { Typography, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import useEmblaCarousel from 'embla-carousel-react'
import theme from "../../theme.js";

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const useStyles = makeStyles(theme => ({
    embla: {
        overflow: "hidden",
        width: "100%",
        height: "100%",
    },
    embla__container: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    navButton: {
        padding: theme.spacing(1),
        minWidth: "0",
    },
    embla__next: {
    },
    embla__prev: {
    },
}));

export default function GalleryDialogSlider({children, 
    initialSlideIndex = 0,
    renderMeta = (index)=>{},
    onSlideChange = (index)=>{},
    containerRef,
}) {
    const classes = useStyles();

    const [emblaRef, embla] = useEmblaCarousel({
        loop: false,
        skipSnaps: false
    });

    const [state, setState] = React.useState({
        currentSlideIndex: initialSlideIndex,
        canScrollPrev: false,
        canScrollNext: false,
    });
    const updateState = useCallback(() => {
        setState(state => ({
            ...state,
            currentSlideIndex: embla.selectedScrollSnap(),
            canScrollPrev: embla.canScrollPrev(),
            canScrollNext: embla.canScrollNext(),
        }))
    }, [embla, setState]);
    

    //const [scaleValues, setScaleValues] = React.useState([]);

    /*const onScroll = useCallback(() => {
        if (!embla) return;
    
        const scrollProgress = embla.scrollProgress();

        //console.log("scrollPrograss", scrollProgress);
    
        const engine = embla.dangerouslyGetEngine();
        const styles = embla.scrollSnapList().map((scrollSnap, index) => {
            if (!embla.slidesInView().includes(index)) return 0;
            let diffToTarget = scrollSnap - scrollProgress;
        
            if (engine.options.loop) {
                engine.slideLooper.loopPoints.forEach((loopItem) => {
                const target = loopItem.getTarget();
                    if (index === loopItem.index && target !== 0) {
                        const sign = Math.sign(target);
                        if (sign === -1) diffToTarget = scrollSnap - (1 + scrollProgress);
                        if (sign === 1) diffToTarget = scrollSnap + (1 - scrollProgress);
                    }
                });
            }
            const scale = 1 - Math.abs(diffToTarget * SCALE_FACTOR);
            return numberWithinRange(scale, 0, 1);
        });
        //console.log(styles);
        //setScaleValues(styles);
      }, [embla, setScaleValues]);*/

    const handleOnSlideChange = useCallback(() => {
        onSlideChange(embla.selectedScrollSnap());
    }, [embla, onSlideChange]);

    useEffect(() => {
        if (!embla) return;

        embla
            .on("select", updateState)
            .on("select", handleOnSlideChange)
        ;

        embla
            .scrollTo(state.currentSlideIndex, true)
        ;
      }, [embla, state.currentSlideIndex, updateState, handleOnSlideChange]);

    const scrollPrev = useCallback(() => {
        if (embla) embla.scrollPrev()
    }, [embla])
    
    const scrollNext = useCallback(() => {
        if (embla) embla.scrollNext()
    }, [embla])

    const slideMeta = renderMeta(state.currentSlideIndex);

    return <>
        <div className={classes.embla} ref={emblaRef}>
            <div ref={containerRef} className={classes.embla__container}>
                {children}
            </div>
        </div>
        <div className="GalleryDialogSlider-Controls">
            {slideMeta}
            <div style={{
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center",
                padding: ".5rem",
            }}>
                <IconButton
                    className={[classes.navButton, classes.embla__prev].join(" ")}
                    onClick={scrollPrev}
                    size="large">
                    <ChevronLeftIcon />
                </IconButton>
                <Typography variant="subtitle1" className="upper" style={{
                    color: theme.palette.primary.main, 
                    textAlign: "center",
                    display: "block",
                }}>
                    {state.currentSlideIndex+1}/{children.length}
                </Typography>
                <IconButton
                    className={[classes.navButton, classes.embla__next].join(" ")}
                    onClick={scrollNext}
                    size="large">
                    <ChevronRightIcon />
                </IconButton>
            </div>
        </div>
    </>;
}